import React from "react";
import {
  Divider,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  SvgIconProps,
  Grid,
  Paper,
  Box,
} from "@mui/material";
import { KeyboardArrowRight } from "@mui/icons-material";

import { styles } from "./styles";

interface IMenuListItem {
  icon: React.ReactElement<SvgIconProps>;
  name: string;
  action: () => void;
  className?: string;
  hasArrow: boolean;
  cardMode?: boolean;
  disabled?: boolean;
}

export default function MenuListItem({
  icon,
  name,
  action,
  className,
  hasArrow,
  cardMode,
  disabled = false,
}: IMenuListItem) {
  if (cardMode) {
    return (
      <Grid item sx={{ background: "#f5f5f5" }} xs={6}>
        {/* xs={6} */}
        <ListItem disablePadding className={className} sx={{ ...styles.listItemCard }}>
          <ListItemButton disabled={disabled} onClick={action}>
            <Paper elevation={2} sx={styles.paperCard}>
              <Box> {icon && <ListItemIcon sx={styles.iconCard}>{icon}</ListItemIcon>}</Box>
              <Box>
                <ListItemText
                  id="#"
                  primary={name}
                  primaryTypographyProps={{
                    variant: "subtitle2",
                  }}
                />
              </Box>
            </Paper>
          </ListItemButton>
        </ListItem>
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <ListItem disablePadding className={className} sx={styles.listItem}>
        <ListItemButton disabled={disabled} onClick={action}>
          {icon && <ListItemIcon sx={styles.icon}>{icon}</ListItemIcon>}
          <ListItemText
            id="#"
            primary={name}
            primaryTypographyProps={{
              variant: "body2",
            }}
          />
          {hasArrow && <KeyboardArrowRight sx={styles.arrowIcon} />}
        </ListItemButton>
      </ListItem>
      <Divider />
    </Grid>
  );
}
